<template>
    <div style="width:100%;background: #f7fbfc">
        <div style="height:240px;padding:8px;overflow-y:scroll;">
            <iframe src="https://apisdk.lnqwe.com/uc/user/real_name_cert" style="width:100%;height:100%;overflow-y:scroll;background:#fff;" frameborder="0"></iframe>
        </div>
        <div style="display:flex;padding:10px;justify-content: center;margin-left: -12px;">
         <van-button type="primary" size="small" style="width:100px;margin-left:10px" @click="sureCert">确定</van-button>
       </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
        }
    },
    computed: {
        ...mapState(['componentParams'])
    },
    methods: {
        sureCert() {
            this.$store.commit('SHOW', {
                name: 'Certification',
                params: { cert_msg: this.componentParams.cert_msg, is_close: false }
            })
        }
    }
}
</script>
